var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6559 17.4287C15.2702 18.5372 13.5125 19.2 11.6 19.2C7.12649 19.2 3.5 15.5735 3.5 11.1C3.5 6.62649 7.12649 3 11.6 3C16.0735 3 19.7 6.62649 19.7 11.1C19.7 13.0125 19.0372 14.7702 17.9287 16.1559L21.2364 19.4636C21.5879 19.8151 21.5879 20.3849 21.2364 20.7364C20.8849 21.0879 20.3151 21.0879 19.9636 20.7364L16.6559 17.4287ZM5.3 11.1C5.3 7.62061 8.12061 4.8 11.6 4.8C15.0794 4.8 17.9 7.62061 17.9 11.1C17.9 12.7973 17.2288 14.3379 16.1373 15.4707C16.1065 15.4944 16.0768 15.5204 16.0486 15.5486C16.0204 15.5768 15.9944 15.6065 15.9707 15.6373C14.8379 16.7288 13.2973 17.4 11.6 17.4C8.12061 17.4 5.3 14.5794 5.3 11.1Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4b38f6b7c5b3db66e8c7cabaa1a3233c.svg";
export { ForwardRef as ReactComponent };